"use strict";

var _regeneratorRuntime = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _slicedToArray = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var _defineProperty = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");

var _classCallCheck = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : new P(function (resolve) {
        resolve(result.value);
      }).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

require("isomorphic-fetch");

var sparqljs_1 = require("sparqljs");

var sparqljson_parse_1 = require("sparqljson-parse");

var sparqlxml_parse_1 = require("sparqlxml-parse"); // tslint:disable-next-line:no-var-requires


var n3 = require('n3');
/**
 * A SparqlEndpointFetcher can send queries to SPARQL endpoints,
 * and retrieve and parse the results.
 */


var SparqlEndpointFetcher =
/*#__PURE__*/
function () {
  function SparqlEndpointFetcher(args) {
    var _this = this,
        _this$sparqlParsers;

    _classCallCheck(this, SparqlEndpointFetcher);

    args = args || {};
    this.fetchCb = args.fetch || fetch;
    this.sparqlJsonParser = new sparqljson_parse_1.SparqlJsonParser(args);
    this.sparqlXmlParser = new sparqlxml_parse_1.SparqlXmlParser(args);
    this.sparqlParsers = (_this$sparqlParsers = {}, _defineProperty(_this$sparqlParsers, SparqlEndpointFetcher.CONTENTTYPE_SPARQL_JSON, {
      parseBooleanStream: function parseBooleanStream(sparqlResponseStream) {
        return _this.sparqlJsonParser.parseJsonBooleanStream(sparqlResponseStream);
      },
      parseResultsStream: function parseResultsStream(sparqlResponseStream) {
        return _this.sparqlJsonParser.parseJsonResultsStream(sparqlResponseStream);
      }
    }), _defineProperty(_this$sparqlParsers, SparqlEndpointFetcher.CONTENTTYPE_SPARQL_XML, {
      parseBooleanStream: function parseBooleanStream(sparqlResponseStream) {
        return _this.sparqlXmlParser.parseXmlBooleanStream(sparqlResponseStream);
      },
      parseResultsStream: function parseResultsStream(sparqlResponseStream) {
        return _this.sparqlXmlParser.parseXmlResultsStream(sparqlResponseStream);
      }
    }), _this$sparqlParsers);
  }
  /**
   * Get the query type of the given query.
   *
   * This will parse the query and thrown an exception on syntax errors.
   *
   * @param {string} query A query.
   * @return {"SELECT" | "ASK" | "CONSTRUCT" | "UNKNOWN"} The query type.
   */


  _createClass(SparqlEndpointFetcher, [{
    key: "getQueryType",
    value: function getQueryType(query) {
      var parsedQuery = new sparqljs_1.Parser().parse(query);
      return parsedQuery.type === 'query' ? parsedQuery.queryType === 'DESCRIBE' ? 'CONSTRUCT' : parsedQuery.queryType : "UNKNOWN";
    }
    /**
     * Send a SELECT query to the given endpoint URL and return the resulting bindings stream.
     * @see IBindings
     * @param {string} endpoint A SPARQL endpoint URL. (without the `?query=` suffix).
     * @param {string} query    A SPARQL query string.
     * @return {Promise<NodeJS.ReadableStream>} A stream of {@link IBindings}.
     */

  }, {
    key: "fetchBindings",
    value: function fetchBindings(endpoint, query) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee() {
        var _ref, _ref2, contentType, responseStream, parser;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.fetchRawStream(endpoint, query, SparqlEndpointFetcher.CONTENTTYPE_SPARQL);

              case 2:
                _ref = _context.sent;
                _ref2 = _slicedToArray(_ref, 2);
                contentType = _ref2[0];
                responseStream = _ref2[1];
                parser = this.sparqlParsers[contentType];

                if (parser) {
                  _context.next = 9;
                  break;
                }

                throw new Error('Unknown SPARQL results content type: ' + contentType);

              case 9:
                return _context.abrupt("return", parser.parseResultsStream(responseStream));

              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    }
    /**
     * Send an ASK query to the given endpoint URL and return a promise resolving to the boolean answer.
     * @param {string} endpoint A SPARQL endpoint URL. (without the `?query=` suffix).
     * @param {string} query    A SPARQL query string.
     * @return {Promise<boolean>} A boolean resolving to the answer.
     */

  }, {
    key: "fetchAsk",
    value: function fetchAsk(endpoint, query) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2() {
        var _ref3, _ref4, contentType, responseStream, parser;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.fetchRawStream(endpoint, query, SparqlEndpointFetcher.CONTENTTYPE_SPARQL);

              case 2:
                _ref3 = _context2.sent;
                _ref4 = _slicedToArray(_ref3, 2);
                contentType = _ref4[0];
                responseStream = _ref4[1];
                parser = this.sparqlParsers[contentType];

                if (parser) {
                  _context2.next = 9;
                  break;
                }

                throw new Error('Unknown SPARQL results content type: ' + contentType);

              case 9:
                return _context2.abrupt("return", parser.parseBooleanStream(responseStream));

              case 10:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
    }
    /**
     * Send a CONSTRUCT/DESCRIBE query to the given endpoint URL and return the resulting triple stream.
     * @param {string} endpoint A SPARQL endpoint URL. (without the `?query=` suffix).
     * @param {string} query    A SPARQL query string.
     * @return {Promise<Stream>} A stream of triples.
     */

  }, {
    key: "fetchTriples",
    value: function fetchTriples(endpoint, query) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3() {
        var rawStream;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this.fetchRawStream(endpoint, query, SparqlEndpointFetcher.CONTENTTYPE_TURTLE);

              case 2:
                rawStream = _context3.sent[1];
                return _context3.abrupt("return", rawStream.pipe(new n3.StreamParser({
                  format: SparqlEndpointFetcher.CONTENTTYPE_TURTLE
                })));

              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));
    }
    /**
     * Send a query to the given endpoint URL and return the resulting stream.
     *
     * This will only accept responses with the application/sparql-results+json content type.
     *
     * @param {string} endpoint     A SPARQL endpoint URL. (without the `?query=` suffix).
     * @param {string} query        A SPARQL query string.
     * @param {string} acceptHeader The HTTP accept to use.
     * @return {Promise<[string, NodeJS.ReadableStream]>} The content type and SPARQL endpoint response stream.
     */

  }, {
    key: "fetchRawStream",
    value: function fetchRawStream(endpoint, query, acceptHeader) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee4() {
        var url, headers, httpResponse, responseStream, contentType;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                url = endpoint + '?query=' + encodeURIComponent(query); // Initiate request

                headers = new Headers();
                headers.append('Accept', acceptHeader);
                _context4.next = 5;
                return this.fetchCb(url, {
                  headers: headers
                });

              case 5:
                httpResponse = _context4.sent;
                // Wrap WhatWG readable stream into a Node.js readable stream
                // If the body already is a Node.js stream (in the case of node-fetch), don't do explicit conversion.
                responseStream = require('is-stream')(httpResponse.body) ? httpResponse.body : require('node-web-streams').toNodeReadable(httpResponse.body); // Determine the content type and emit it to the stream

                contentType = httpResponse.headers.get('Content-Type') || '';

                if (contentType.indexOf(';') > 0) {
                  contentType = contentType.substr(0, contentType.indexOf(';'));
                } // Emit an error if the server returned an invalid response


                if (!httpResponse.ok) {
                  setImmediate(function () {
                    return responseStream.emit('error', new Error('Invalid SPARQL endpoint (' + endpoint + ') response: ' + httpResponse.statusText));
                  });
                }

                return _context4.abrupt("return", [contentType, responseStream]);

              case 11:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));
    }
  }]);

  return SparqlEndpointFetcher;
}();

SparqlEndpointFetcher.CONTENTTYPE_SPARQL_JSON = 'application/sparql-results+json';
SparqlEndpointFetcher.CONTENTTYPE_SPARQL_XML = 'application/sparql-results+xml';
SparqlEndpointFetcher.CONTENTTYPE_SPARQL = "".concat(SparqlEndpointFetcher.CONTENTTYPE_SPARQL_JSON, ";q=1.0,").concat(SparqlEndpointFetcher.CONTENTTYPE_SPARQL_XML, ";q=0.7");
SparqlEndpointFetcher.CONTENTTYPE_TURTLE = 'text/turtle';
exports.SparqlEndpointFetcher = SparqlEndpointFetcher;